import React, { Component } from "react";
import { connect } from "react-redux";

class BillingAddressSelection extends Component {
	formatSearchAddress(address) {
		let formattedAddres = address.address;
		if (address.address2) formattedAddres += " " + address.address2;
		formattedAddres += " " + address.formatted_location;

		return formattedAddres;
	}

	render() {
		const { address, billing = null, mapHandler } = this.props;

		return (
			<div className="store-location">
				<div className="store-row">
					<div className="store-col">
						<div className="store-title">
							{address.fname} {address.lname}
						</div>
					</div>
					<div className="store-col">
						<div>{address.address}</div>
						{address.address2 && <div>{address.address2}</div>}
						{address.formatted_location && <div>{address.formatted_location}</div>}
					</div>
					<div className="store-col">
						<div className={"btn select-store" + (billing.id === address.id ? " active" : "")} onClick={() => this.props.handleSelect(address)}>
							Bill to this location<span className="icon-checkmark" />
						</div>
					</div>
				</div>
				<div className="store-row">
					<div className="store-col">
						<a className="see-map" onClick={() => mapHandler(this.formatSearchAddress(address))}>
							<span className="icon-location" />See on map
						</a>
					</div>
					<div className="store-col">
						{address.phone && <div>{address.phone}</div>}
						{address.email && <div>{address.email}</div>}
					</div>
					<div className="store-col" />
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		billing: state.checkout.billing
	};
};

export default connect(mapStateToProps)(BillingAddressSelection);



// WEBPACK FOOTER //
// ./src/components/checkout/billing/BillingAddressSelection.js